import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getCleaningStatInfo = createAsyncThunk('dashboard/cleaning-statistics', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/property-schedule/get-cleaning-statistics', { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRecentCleanning = createAsyncThunk('dashboard/recent-cleanning', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/property-schedule/get-recent-property-schedules', { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getUpcomingCleanning = createAsyncThunk('dashboard/upcoming-cleanning', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/property-schedule/get-upcoming-check-in-property-schedules', { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCleanningStatus = createAsyncThunk('dashboard/cleanning-status', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/property-schedule/get-cleaning-status-property-schedules', { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  dashboardCounts: null,
  recentCleanningData: [],
  upcomingCleanningData: [],
  cleanningStatusData: [],
  error: null
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCleaningStatInfo.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCleaningStatInfo.fulfilled, (state, action) => {
        state.isLoading = false
        state.dashboardCounts = action.payload?.data?.data
      })
      .addCase(getCleaningStatInfo.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getRecentCleanning.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRecentCleanning.fulfilled, (state, action) => {
        state.isLoading = false
        state.recentCleanningData = action.payload?.data?.data
      })
      .addCase(getRecentCleanning.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getUpcomingCleanning.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getUpcomingCleanning.fulfilled, (state, action) => {
        state.isLoading = false
        state.upcomingCleanningData = action.payload?.data?.data
      })
      .addCase(getUpcomingCleanning.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCleanningStatus.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCleanningStatus.fulfilled, (state, action) => {
        state.isLoading = false
        state.cleanningStatusData = action.payload?.data?.data
      })
      .addCase(getCleanningStatus.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default dashboardSlice.reducer
